var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.nRow),function(i){return _c('tr',{key:i,staticClass:"animate-pulse"},_vm._l((_vm.nCol),function(col){return _c('td',{key:`col_${col}`},[_c('p',{staticClass:"h-4 bg-gray-200 w-full"})])}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }